/**
 * Focus to another input when maxlength has been reached
*/

import EventBus from './../event-bus.js'
import jQuery from 'jquery'

const MaxLengthFocus = {
    
    init() {

        jQuery(document)
            .on('keyup', 'input.max-length-focus', MaxLengthFocus.handleChange)
            .on('change', 'select.max-length-focus', MaxLengthFocus.handleChange)
        
    },
    
    handleChange(event) {
        
        let
            input = jQuery(event.target),
            maxLength = input.attr('maxlength'),
            isSelect = input.is('select'),
            value = input.val(),
            key = isSelect ? null : (event.keyCode || event.charCode),
            validKey = (key >= 48 && key <= 57) || (key >= 65 && key <= 90)
            
        if (isSelect ? (value.length === 0) : (!maxLength || value.length < maxLength || !validKey)) {
            return false
        }

        var target = jQuery(input.data('focus-to'))
        if (target.length === 0) {
            return
        }
        
        target.focus()
        
    }
    
}

EventBus.subscribe('init-modules', MaxLengthFocus.init)

export default MaxLengthFocus